<template>
  <div>
    <br>
    <v-data-table :headers="headers" :items="parosSinEspecificar" :disabled="loadingParosSinEspecificar"
      :loading="loadingParosSinEspecificar" show-select item-key="idParo" v-model="parosSeleccionados">
      <template v-slot:top>
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <datePicker v-model="parametrosParos.desde" format="YYYY-MM-DD" :maxDate="parametrosParos.hasta"
                label="Desde (Opcional)" clearable maxToday />
            </v-col>
            <v-col cols="6">
              <datePicker v-model="parametrosParos.hasta" format="YYYY-MM-DD" :minDate="parametrosParos.desde"
                label="Hasta (Opcional)" clearable maxToday />
            </v-col>
          </v-row>
        </v-col>
        <div class="d-flex justify-center align-center">
          <v-autocomplete v-model="parametrosParos.idArea" label="Área (Opcional)" :items="areas" item-text="nombre"
            item-value="idArea" class="mx-2" :disabled="loadingParosSinEspecificar"
            :loading="loadingParosSinEspecificar" clearable/>
          <v-autocomplete v-model="parametrosParos.idMaquinaInstancia" label="Máquina (Opcional)" :items="maquinaInstancias"
            :item-text="nombreMaquina" item-value="idMaquinaIns" class="mx-2" :disabled="loadingParosSinEspecificar"
            :loading="loadingParosSinEspecificar" clearable/>
          <v-btn @click="getParosSinEspecificar()" color="primary" :disabled="loadingParosSinEspecificar"
            :loading="loadingParosSinEspecificar">Buscar</v-btn>
        </div>
        <v-col cols="12">
          <v-btn v-if="parosSeleccionados.length > 0" color="primary" dark right @click="abrirDialogMasivo">
            Actualizar Seleccionados ({{ parosSeleccionados.length }})
          </v-btn>
        </v-col>
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="abrirDialogModificar(item)">
              mdi-pen
            </v-icon>
          </template>
          <span class="white--text">Actualizar</span>
        </v-tooltip>
      </template>
      <template v-slot:item.duracionSegundos="{ item }">
        {{ formatearTiempo(item.duracionSegundos) }}
      </template>
    </v-data-table>

    <v-dialog v-model="dialogActualizar" persistent width="auto">
      <v-card>
        <v-card-title>Actualizar información de paro</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" class="text-body-2">Inicio: {{ paroActualizado.inicio }}</v-col>
            <v-col cols="6" class="text-body-2">Fin: {{ paroActualizado.fin }} </v-col>
            <v-col cols="6" class="text-body-2">Área: {{ paroActualizado.area }}</v-col>
            <v-col cols="6" class="text-body-2">Máquina {{ paroActualizado.area }} </v-col>
            <v-col cols="6" class="text-body-2">
              <v-autocomplete v-model="paroActualizado.idParoTipo" label="Motivo" :items="parosTiposFiltrados"
                item-value="idParoTipo" item-text="nombre" :loading="loadingActualizarParos" />
            </v-col>
            <v-col cols="6" class="text-body-2">
              <v-autocomplete v-model="paroActualizado.idSubParoTipo" label="Submotivo" :items="subParosTiposFiltrados"
                item-value="idSubParoTipo" item-text="nombreSubParoTipo" :loading="loadingActualizarParos" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialogActualizar = !dialogActualizar" text class="ml-auto" color="success"
            :loading="loadingActualizarParos">Cancelar</v-btn>
          <v-btn v-if="!paroTipoSinEspecificar" @click="putParomodificado()" text color="error"
            :loading="loadingActualizarParos">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMasivo" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          Actualizar {{ parosSeleccionados.length }} paros
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="6">
                <v-select v-model="paroActualizado.idParoTipo" :items="parosTiposFiltrados" item-text="nombre"
                  item-value="idParoTipo" label="Motivo" required :loading="loadingActualizarParos" />
              </v-col>
              <v-col cols="6">
                <v-select v-model="paroActualizado.idSubParoTipo" :items="subParosTiposFiltrados"
                  item-text="nombreSubParoTipo" item-value="idSubParoTipo" label="Submotivo"
                  :disabled="!paroActualizado.idParoTipo" :loading="loadingActualizarParos" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="cerrarDialogModificar()"
            :loading="loadingActualizarParos">Cancelar</v-btn>
          <v-btn text color="error" :loading="loadingActualizarParos" @click="putParomodificado">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import { color } from 'd3'

export default {
  data() {
    return {
      oeeFactores: [],
      tipoParos: [],
      tipoSubparos: [],
      parosSinEspecificar: [],
      parosSeleccionados: [],
      areas: [],
      maquinaInstancias: [],

      parametrosParos: {
        desde: null,
        hasta: null,
        idArea: null,
        idMaquinaInstancia: null
      },
      datosMasivos: {
        idParoTipo: null,
        idSubParoTipo: null,
      },

      dialogMasivo: false,
      dialogActualizar: false,


      loadingParosSinEspecificar: false,
      loadingActualizarParos: false,
      paroActualizado: {},
      idOEEDisponibilidad: null,
    }
  },
  methods: {
    nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    initialize() {
      this.getOEEFactores();
      // this.getParosSinEspecificar();
      this.getMaquinaInstancias();
      this.getAreas();
      this.getTipoParos();
      this.getTipoSubParos();
    },

    getOEEFactores() {
      axios
        .get("/OEEFactores")
        .then((response) => {
          this.oeeFactores = response.data;
          this.idOEEDisponibilidad = this.oeeFactores.filter(item => item.nombre?.toUpperCase() === "DISPONIBILIDAD".toUpperCase())?.[0]?.idOEEFactor;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTipoParos() {
      axios
        .get("/ParoTipos")
        .then((response) => {
          this.tipoParos = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTipoSubParos() {
      axios
        .get("/SubParoTipos")
        .then((response) => {
          this.tipoSubparos = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAreas() {
      axios
        .get("/Areas")
        .then(response => this.areas = response.data)
        .catch(error => console.log(error))
    },
    getMaquinaInstancias() {
      axios
        .get("/MaquinaInstancias")
        .then(response => this.maquinaInstancias = response.data)
        .catch(error => console.log(error))
    },

    getParosSinEspecificar() {
      this.parosSinEspecificar = [];
      this.loadingParosSinEspecificar = true;
      let params = [];

      if (this.parametrosParos.idArea != null && this.parametrosParos.idArea > 0) {
        params.push(`IdArea=${this.parametrosParos.idArea}`);
      }

      if (this.parametrosParos.idMaquinaInstancia != null && this.parametrosParos.idMaquinaInstancia > 0) {
        params.push(`IdMaquinaIns=${this.parametrosParos.idMaquinaInstancia}`);
      }

      if (this.parametrosParos.desde) {
        params.push(`desde=${encodeURIComponent(this.parametrosParos.desde)}`);
      }

      if (this.parametrosParos.hasta) {
        params.push(`hasta=${encodeURIComponent(this.parametrosParos.hasta)}`);
      }

      const queryString = params.length > 0 ? `?${params.join("&")}` : "";

      axios
        .get(`Paros/ParosSinEspecificar${queryString}`)
        .then(response => {
          this.parosSinEspecificar = response.data;
        })
        .catch(error => {
          console.error("Error al obtener paros sin especificar:", error);
        })
        .finally(() => {
          this.loadingParosSinEspecificar = false;
        });
    },
    putParomodificado() {
      this.loadingActualizarParos = true;
      const idsReducidos = this.parosSeleccionados.length > 0
        ? this.parosSeleccionados.flatMap(p => p.idsReducidos || [p.idParo])
        : (this.paroActualizado.idsReducidos || []);

      const payload = {
        idParoTipo: this.paroActualizado.idParoTipo,
        idSubParoTipo: this.paroActualizado.idSubParoTipo || null,
        idsReducidos: idsReducidos,
      };

      axios
        .put("/paros/ActualizarSinEspecificar", payload)
        .then(() => {
          this.cerrarDialogModificar();
          this.getParosSinEspecificar();
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.parosSeleccionados = [];
          this.loadingActualizarParos = false;
        })
    },

    abrirDialogMasivo() {
      this.datosMasivos.idParoTipo = null;
      this.datosMasivos.idSubParoTipo = null;
      this.dialogMasivo = true;
    },
    abrirDialogModificar(item) {
      this.paroActualizado = null;
      this.paroActualizado = item;
      this.dialogActualizar = true;
    },
    cerrarDialogModificar() {
      this.dialogMasivo = false;
      this.dialogActualizar = false;
      this.initialize();
      this.paroActualizado = {};
      this.datosMasivos = {
        idParoTipo: null,
        idSubParoTipo: null,
      };
    },
    formatearTiempo(segundos) {
      const negativo = segundos < 0;
      segundos = Math.abs(segundos);

      const dias = Math.floor(segundos / 86400);
      const horas = Math.floor((segundos % 86400) / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      const seg = Math.floor(segundos % 60);

      const partes = [];
      if (dias > 0) partes.push(`${dias}d`);
      partes.push(String(horas).padStart(2, '0'));
      partes.push(String(minutos).padStart(2, '0'));
      partes.push(String(seg).padStart(2, '0'));
      return (negativo ? '-' : '') + (dias > 0 ? partes[0] + 'D ' : '') + partes.slice(dias > 0 ? 1 : 0).join(':');
    },
  },
  computed: {
    headers() {
      const base = [
        {
          text: 'Inicio Paro', value: 'inicio', align: "center", sortable: true,
        },
        {
          text: 'Fin Paro', value: 'fin', align: "center", sortable: true,
        },
        {
          text: 'Duración Paro', value: 'duracionSegundos', align: "center", sortable: true,
        },
        {
          text: 'Área', value: 'area', align: "center", sortable: true,
        },
        {
          text: 'Máquina', value: 'maquina', align: "center", sortable: true,
        }
      ];
      if (this.parosSeleccionados.length === 0) {
        base.push({ text: 'Acciones', value: 'acciones', sortable: false });
      }
      return base;
    },
    parosTiposFiltrados() {
      if (this.idOEEDisponibilidad != null) return this.tipoParos.filter(tp => tp.idOEEFactor === this.idOEEDisponibilidad);
      else {
        this.paroActualizado.idParoTipo = null
        return []
      }
    },
    subParosTiposFiltrados() {
      this.paroActualizado.idSubParoTipo = null

      if (this.paroActualizado.idParoTipo != null) return this.tipoSubparos.filter(tp => tp.idParoTipo === this.paroActualizado.idParoTipo);
      return []
    },

    paroTipoSinEspecificar() {
      let idParo = this.tipoParos.filter(item => item.nombre?.toUpperCase() === "SIN ESPECIFICAR".toUpperCase())?.[0]?.idParoTipo;
      if ((idParo == this.paroActualizado.idParoTipo) || this.paroActualizado.idParoTipo == null) return true
      return false
    },
  },
}
</script>